import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'aa-avatar-icon',
    templateUrl: './avatar-icon.component.html',
    styleUrls: [
        './avatar-icon.component.scss'
    ],
    standalone: false
})
export class AvatarIconComponent implements OnInit
{
    @Input() src: string = './assets/images/AurorA.png';
    @Input() size: string = '48px';
    @Input() alt: string = '';
    @Input() icon: string = '';
    @Input() withBg: boolean = true;
    @Input() click: () => {} = null;
    public overloaded: boolean = false;

    constructor() { }

    ngOnInit ()
    {
        this.overloaded = this.icon !== '';
    }

    onClick  ()
    {
        if (this.click !== null)
        {
            this.click();
        }
    }
}
